import { call, put, takeEvery, select, fork } from "redux-saga/effects"
import AssignmentType from "./actionTypes"

import AssignmentAction from "./actions"
import AssignmentAPI from "helpers/assignment_backend_helper"
import { toast } from "react-toastify"

function* fetchStaffTrouserList({ payload }) {
  yield put(
    AssignmentAction.getStaffTrouserListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(AssignmentAPI.getStaffList, "トラウザーズ")
    yield put(
      AssignmentAction.getStaffTrouserListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      AssignmentAction.getStaffTrouserListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchStaffJacketList({ payload }) {
  yield put(
    AssignmentAction.getStaffJacketListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(AssignmentAPI.getStaffList, "上着")
    yield put(
      AssignmentAction.getStaffJacketListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      AssignmentAction.getStaffJacketListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchRtwOrderList({ payload }) {
  yield put(
    AssignmentAction.getRtwOrderListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(AssignmentAPI.getRtwOrderList, payload)
    yield put(
      AssignmentAction.getRtwOrderListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      AssignmentAction.getRtwOrderListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchRtwOrderSizeList({ payload }) {
  yield put(
    AssignmentAction.getRtwOrderSizeListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(AssignmentAPI.getRtwOrderSizeList, payload)
    yield put(
      AssignmentAction.getRtwOrderSizeListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      AssignmentAction.getRtwOrderSizeListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchOrderList({ payload }) {
  yield put(
    AssignmentAction.getOrderListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(AssignmentAPI.getOrderList, payload)
    yield put(
      AssignmentAction.getOrderListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      AssignmentAction.getOrderListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchWeekList({ payload, action }) {
  yield put(
    AssignmentAction.getWeekListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(AssignmentAPI.getWeekList, payload)
    yield put(
      AssignmentAction.getWeekListSuccess({
        loading: false,
        data,
      })
    )
    action(data)
  } catch (error) {
    console.log(error)
    yield put(
      AssignmentAction.getWeekListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchputRtwOrder({ payload, action }) {
  yield put(
    AssignmentAction.putRtwOrderSuccess({
      loading: false,
      data: {},
    })
  )
  try {
    let { data } = yield call(AssignmentAPI.putRtwOrder, payload)

    yield put(
      AssignmentAction.putRtwOrderSuccess({
        loading: false,
        data,
      })
    )
    action(data)
  } catch (error) {
    toast.error(
      error?.message ||
        "保存に失敗しました。入力された内容をもう一度ご確認ください。"
    )
    yield put(
      AssignmentAction.putRtwOrderSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchputOrder({ payload, action }) {
  yield put(
    AssignmentAction.putOrderSuccess({
      loading: false,
      data: {},
    })
  )
  try {
    let { data } = yield call(AssignmentAPI.putOrder, payload)

    yield put(
      AssignmentAction.putOrderSuccess({
        loading: false,
        data,
      })
    )
    action(data)
  } catch (error) {
    toast.error(
      error?.message ||
        "保存に失敗しました。入力された内容をもう一度ご確認ください。"
    )
    yield put(
      AssignmentAction.putOrderSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchdeleteRtwOrder({ payload, action }) {
  yield put(
    AssignmentAction.deleteRtwOrderSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(AssignmentAPI.deleteRtwOrder, payload)

    yield put(
      AssignmentAction.deleteRtwOrderSuccess({
        loading: false,
        data,
      })
    )
    action(payload)
  } catch (error) {
    toast.error(
      error?.message ||
        "保存に失敗しました。入力された内容をもう一度ご確認ください。"
    )
    yield put(
      AssignmentAction.deleteRtwOrderSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchdeleteOrder({ payload, action }) {
  yield put(
    AssignmentAction.deleteOrderSuccess({
      loading: false,
      data: {},
    })
  )
  try {
    let { data } = yield call(AssignmentAPI.deleteOrder, payload)

    yield put(
      AssignmentAction.deleteOrderSuccess({
        loading: false,
        data,
      })
    )
    action(data)
  } catch (error) {
    toast.error(
      error?.message ||
        "保存に失敗しました。入力された内容をもう一度ご確認ください。"
    )
    yield put(
      AssignmentAction.deleteOrderSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchpatchData({ payload, action }) {
  yield put(
    AssignmentAction.patchDataSuccess({
      loading: false,
      data: {},
    })
  )
  try {
    let { data } = yield call(AssignmentAPI.patchData, payload)

    yield put(
      AssignmentAction.patchDataSuccess({
        loading: false,
        data,
      })
    )

    action({ id: payload.id || payload })
  } catch (error) {
    toast.error(
      error?.message ||
        "保存に失敗しました。入力された内容をもう一度ご確認ください。"
    )
    yield put(
      AssignmentAction.patchDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* putDataLocalState({ payload, action }) {
  try {
    let { data } = yield call(
      AssignmentAPI.getSingleOrder,
      payload.weekId,
      payload.id
    )

    yield put(
      AssignmentAction.putDataLocalSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
  }
}

function* putRTWDataLocalState({ payload, action }) {
  try {
    let { data } = yield call(
      AssignmentAPI.getSingleRTWOrder,
      payload.weekId,
      payload.id
    )
    yield put(
      AssignmentAction.putRTWDataLocalSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
  }
}

function* assignmentSaga() {
  yield takeEvery(
    AssignmentType.GET_ASSIGNMENT_STAFF_TROUSER_LIST,
    fetchStaffTrouserList
  )
  yield takeEvery(
    AssignmentType.GET_ASSIGNMENT_STAFF_JACKET_LIST,
    fetchStaffJacketList
  )
  yield takeEvery(
    AssignmentType.GET_ASSIGNMENT_RTW_ORDER_LIST,
    fetchRtwOrderList
  )
  yield takeEvery(
    AssignmentType.GET_ASSIGNMENT_RTW_ORDER_SIZE_LIST,
    fetchRtwOrderSizeList
  )
  yield takeEvery(AssignmentType.GET_ASSIGNMENT_ORDER_LIST, fetchOrderList)
  yield takeEvery(AssignmentType.GET_ASSIGNMENT_WEEK_LIST, fetchWeekList)
  yield takeEvery(AssignmentType.PUT_ASSIGNMENT_RTW_ORDER, fetchputRtwOrder)
  yield takeEvery(AssignmentType.PUT_ASSIGNMENT_ORDER, fetchputOrder)
  yield takeEvery(
    AssignmentType.DELETE_ASSIGNMENT_RTW_ORDER,
    fetchdeleteRtwOrder
  )
  yield takeEvery(AssignmentType.DELETE_ASSIGNMENT_ORDER, fetchdeleteOrder)
  yield takeEvery(AssignmentType.PATCH_ASSIGNMENT_DATA, fetchpatchData)
  yield takeEvery(
    AssignmentType.PUT_ASSIGNMENT_ORDER_LOCAL_STATE,
    putDataLocalState
  )
  yield takeEvery(
    AssignmentType.PUT_ASSIGNMENT_RTW_ORDER_LOCAL_STATE,
    putRTWDataLocalState
  )
}

export default assignmentSaga
